import React, { useContext } from "react";
import './CSS/ShopCat.css'
import { ShopContext } from "../Context/ShopContext";
import Item from '../Components/Items/Item'

const ShopCat = (props) => {
  const { all_products } = useContext(ShopContext); // Changed from all_product to all_products
  
  // Add a safeguard in case all_products is undefined
  if (!all_products) {
    return <div>Loading products...</div>;
  }

  return (
    <div className='shop-cat'>
      <img src={props.banner} alt="" />

      <div className="shop-cat-products">
        {all_products.map((item, i) => {
          if (props.category === item.category) {
            return <Item 
              key={i} 
              id={item.id}  
              name={item.name} 
              info={item.info} 
              image={item.image}  
              oldPrice={item.oldPrice}  // Make sure these property names match your data
              newPrice={item.newPrice}
            />
          }
          return null;
        })}
      </div>

      <div className="shop-cat-load">
        Explore More
      </div>
    </div>
  )
}

export default ShopCat;